import { useState } from 'react';
import { useAuth } from '../../lib/auth';
import type { OrgChartResponse } from '../../lib/types';
import { useApiQuery } from '../../lib/useApi';
import { EmptyState, ErrorNote, PageHeader, Spinner } from '../../ui/components';

export function OrgChart() {
  const { persona } = useAuth();
  const [mdaCode, setMdaCode] = useState(persona?.mdaCode ?? '');
  const chartQ = useApiQuery<OrgChartResponse>(mdaCode ? `/api/v1/staffdesk/org-chart?mdaCode=${encodeURIComponent(mdaCode)}` : null);

  return (
    <div>
      <PageHeader title="Org chart" subtitle="Active officers grouped by position within an MDA" />
      <div className="mb-4">
        <input className="field-input max-w-[200px]" placeholder="MDA code, e.g. SRC" value={mdaCode} onChange={(e) => setMdaCode(e.target.value)} />
      </div>
      {chartQ.error ? <ErrorNote message={chartQ.error} /> : null}
      {!mdaCode ? (
        <EmptyState title="Enter an MDA code" hint="e.g. SRC, IMM, MOH, ELS, DICT, SBC, DRDM, MLH" />
      ) : chartQ.loading ? (
        <Spinner />
      ) : (chartQ.data?.positions.length ?? 0) === 0 ? (
        <EmptyState title="No active officers" hint={`Nothing found for ${mdaCode}`} />
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {chartQ.data!.positions.map((p) => (
            <div key={p.position} className="card p-4">
              <h3 className="mb-2 text-sm font-bold text-slate-700">{p.position}</h3>
              <div className="space-y-1.5">
                {p.officers.map((o) => (
                  <div key={o.id} className="rounded-lg border border-slate-200 px-2.5 py-1.5 text-xs">
                    <div className="font-mono">{o.personId}</div>
                    <div className="mt-0.5 flex flex-wrap gap-1">
                      {o.roles.length === 0 ? (
                        <span className="text-slate-300">no roles</span>
                      ) : (
                        o.roles.map((r) => (
                          <span key={r} className="rounded bg-slate-100 px-1 py-0.5 text-[10px] text-slate-500">
                            {r}
                          </span>
                        ))
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
